import { ChangeEvent, Fragment, useState } from "react";
import { useIntl } from "react-intl";

import { Tabs } from "@dzambalaorg/ui-kit";

import { UserFormTabs } from "./tabs";
import { UserGeneralForm } from "./general";

export interface IUserDialogFormProps {
  createdAt: string;
}

export const UserDialogForm = (props: IUserDialogFormProps) => {
  const { createdAt } = props;
  const { formatMessage } = useIntl();

  const [value, setValue] = useState(UserFormTabs.general);

  const handleChange = (_event: ChangeEvent<any>, newValue: UserFormTabs): void => {
    setValue(newValue);
  };

  return (
    <Fragment>
      <Tabs value={value} indicatorColor="primary" textColor="primary" onChange={handleChange} sx={{ mb: 2 }}>
        {Object.values(UserFormTabs).map(tab => (
          <Tabs.Tab key={tab} label={formatMessage({ id: `pages.profile.tabs.${tab}` })} value={tab} />
        ))}
      </Tabs>

      <UserGeneralForm createdAt={createdAt} open={value === UserFormTabs.general} />
    </Fragment>
  );
};
